.titleText {
  margin: 0 0.5rem;
}
